import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import _toConsumableArray from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof";
import qs from 'querystring';

var trim = function trim(str) {
  return str ? str.replace(/(^\s*)|(\s*$)/g, '') : str;
};

var util = {
  CARD_CLASS_PREFIX: '_card_',
  filterText: function filterText(text) {
    if (!text) return text;
    return text.replace(/src="\/\//g, 'src="https://'); // 把相对协议改成https （ssr生成方式相对协议会有问题）
  },

  /**
   * 去掉http,使用https
   * @param src
   * @returns {*}
   */
  removeHttp: function removeHttp(src) {
    if (!src) return src; // 兼容 ssr

    var isLocalFile = typeof location === 'undefined' || /^(file|about)/.test(location.protocol);

    if (isLocalFile && /^\/\//.test(src)) {
      return src.replace(/^\/\//, 'https://');
    }

    return src.replace(/^http:/, 'https:');
  },

  /** *
   * 自定义封装jsonp
   * @param url
   * @returns {Promise<unknown>}
   */
  getJSON: function getJSON(url) {
    return new Promise(function (resolve, reject) {
      var funName = 'fun_cloud_seal_callback';

      window[funName] = function (data) {
        resolve(data);
        delete window[funName];
        document.body.removeChild(script);
      };

      var script = document.createElement('script');
      script.src = url.indexOf('?') !== -1 ? "".concat(url, "&callback=").concat(funName) : "".concat(url, "?callback=").concat(funName);

      script.onerror = function (e) {
        reject(e);
        delete window[funName];
        document.body.removeChild(script);
      };

      document.body.appendChild(script);
    });
  },
  getUrlParamObj: function getUrlParamObj() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.replace(/^\?/, '');
    return qs.parse(url);
  },
  getUrlParam: function getUrlParam(key) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.search.replace(/^\?/, '');
    return qs.parse(url)[key];
  },

  /**
   * 避免过多的条件判断，a && a.b && a.b.c && a.b.c.d 简写 getVal(a, 'a.b.c.d')
   * @param obj
   * @param keys
   * @returns {T}
   */
  getVal: function getVal(obj) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return keys.split('.').reduce(function (obj, key) {
      return obj && _typeof(obj) === 'object' ? obj[key] : undefined;
    }, obj);
  },

  /**
   * 解析样式键值对
   * @param str
   * @returns {*}
   */
  getStyleObj: function getStyleObj() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return trim(str).split(';').reduce(function (result, styleStr) {
      var res = result;
      var style = trim(styleStr);

      if (style) {
        var _ref = style.split(':') || [],
            _ref2 = _slicedToArray(_ref, 2),
            val0 = _ref2[0],
            val1 = _ref2[1];

        if (val0 && val1) {
          res[val0] = val1;
        }
      }

      return res;
    }, {});
  },

  /**
   * 替换字符串里面的变量
   * @param str
   * @param ctx
   * @returns {string}
   */
  replaceParams: function replaceParams(str) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (str || '').replace(/\${([\w\W]*?)}/g, function (str, $1) {
      try {
        var fun = new Function(Object.keys(ctx).join(','), "return ".concat($1));
        /* eslint-disable-line */

        return fun.apply(void 0, _toConsumableArray(Object.values(ctx)));
      } catch (e) {
        return str || '';
      }
    });
  },

  /** *
   * 根据参数列表配置和用户传参，返回真正的paramsObj（做了字符串最大长度限制）
   * @param list 参数列表
   * @param obj 用户传参
   * @returns {T | any | {}}
   */
  getParamsObj: function getParamsObj(list, obj) {
    var paramsList = list || [];
    var params = obj || {};
    return paramsList.reduce(function (result, item) {
      var res = result;
      res[item.key] = util.getMaxText(item.key in params ? util.toString(params[item.key]) : item.defaultValue || "${".concat(item.key, "}"), item.maxLength);
      return res;
    }, {}) || {};
  },
  toString: function toString(val) {
    if (val === null || val === undefined) {
      return '';
    }

    return String(val);
  },

  /** *
   * 做字符串截取，超长打点(注意emoji表情)
   * @param text
   * @param maxLength
   * @returns {string|*}
   */
  getMaxText: function getMaxText(text, maxLength) {
    if (!text || !maxLength) return text;
    var array = Array.from(text);
    var length = array.length;

    if (length > maxLength) {
      return "".concat(array.slice(0, maxLength).join(''), "...");
    }

    return text;
  },

  /**
   * 创建style 标签插入head
   * @param id
   * @param styleText
   */
  createCardStyleTag: function createCardStyleTag(id, styleText) {
    // 兼容ssr
    if (!id || !styleText || typeof document === 'undefined') return;
    var dom = document.querySelector("#".concat(id));

    if (dom) {
      dom.innerHTML = styleText;
      return;
    }

    dom = document.createElement('style');
    dom.id = id;
    dom.innerHTML = styleText;
    document.head.appendChild(dom);
  },
  parseJson: function parseJson(text) {
    var dft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    try {
      return JSON.parse(text);
    } catch (e) {
      return dft;
    }
  },

  /**
   * 生产hash
   * @param str
   * @returns {number}
   */
  getToken: function getToken(str) {
    if (!str) return;
    var hash = null;

    for (var i = 0, len = str.length, _hash = 5381; i < len; ++i) {
      _hash += (_hash << 5) + str.charAt(i).charCodeAt();
    }

    return hash & 0x7fffffff;
  }
};
export default util;